import React from "react";
import { Check, Users } from "lucide-react";
const TargetAudience = () => {
  const targetGroups = [{
    title: "Corretores que querem mais controle, autonomia e agilidade",
    description: "Assuma o controle das suas fotografias sem depender de terceiros ou esperas desnecessárias."
  }, {
    title: "Imóveis de locação, médio padrão e fotos do dia a dia",
    description: "Ideal para diversos tipos de imóveis quando você precisa de rapidez e qualidade."
  }, {
    title: "Profissionais que sabem que tempo é dinheiro",
    description: "E que entendem que boas fotos vendem mais rápido e valorizam o seu trabalho."
  }];
  return <section id="para-quem" className="py-16 md:py-24 bg-toctoc-beige/20">
      <div className="container max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row gap-12 items-center">
          <div className="w-full md:w-1/2">
            <h2 className="text-3xl md:text-4xl font-bold text-toctoc-black mb-6">Para quem é o Toc Rápido?</h2>
            
            <div className="space-y-8">
              {targetGroups.map((group, index) => <div key={index} className="flex gap-4">
                  <div className="mt-1 flex-shrink-0">
                    <div className="w-8 h-8 rounded-full bg-toctoc-blue flex items-center justify-center">
                      <Check className="h-5 w-5 text-white" />
                    </div>
                  </div>
                  <div>
                    <h3 className="font-semibold text-lg text-toctoc-black mb-1">{group.title}</h3>
                    <p className="text-toctoc-gray-medium">{group.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
          
          <div className="w-full md:w-1/2 relative">
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-toctoc-blue/10 rounded-full z-0"></div>
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-toctoc-orange/10 rounded-full z-0"></div>
            <div className="relative z-10 rounded-xl overflow-hidden shadow-xl border">
              <img src="https://images.unsplash.com/photo-1721322800607-8c38375eef04" alt="Ambiente imobiliário profissional" className="w-full h-auto" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex flex-col justify-end p-8">
                <div className="flex items-center mb-3">
                  <Users className="h-6 w-6 text-white mr-2" />
                  <p className="text-white font-semibold">Profissionais imobiliários</p>
                </div>
                <h3 className="text-white text-2xl font-bold mb-2">
                  Eleve o padrão das suas apresentações
                </h3>
                <p className="text-white/90">
                  As fotos são o primeiro contato do cliente com o imóvel. Impressione desde o início.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default TargetAudience;